const papoReto = {
  title: "PAPO RETO",
  date: '21/04/2021',
  content: `A máscara aperta
A entrega não chega
Não tenho tempo pra nada

Papo reto

O dia todo em casa
É do quarto pra sala 
É da sala pro quarto

Papo reto?

A loja não abre
Pra visitar 
Pra saber o que comprar

Papo reto?!

E o restaurante não abre
Pra se servir
Sem se contaminar

Papo reto???! 

O remédio disseram
Que podia ajudar
A vacina disseram
Que podia matar

Pap…?????!!!

Entre ficar em casa
Tanto tempo 
Sem enlouquecer

E se arriscar nas ruas
E encontrar quem não teme
Arriscar você

Papo reto

A comida chegou..
Quem mais se arriscou
Pra esse prato chegar?

Papo reto!

E a loja fechou
Que era de alguém
Que uma vida entregou
E viu tudo acabar

Papo mais reto

É todo dia na tv
Só um assunto no jornal
E a fila desse hospital
Nem sedativo tem mais

Papo muito mais reto!!!

Quanta gente pegou
Quanta gente morreu
Cada dia mais perto
De mim e dos meus

Papo muito reto!
Está batendo na porta
Está na nossa cara
É difícil desviar
Ou
Desconversar

Papo muito reto
Não dá pra se esquivar
Nem apontar o dedo
Pra culpar, desculpar

Papo muito reto
Todos sabem quem são
E quem foram
Aqueles que devemos culpar

Mas eu ouço, eu vejo
Que o papo está torto

Está torto demais!

Falamos de tudo e não falamos mais nada
Papos tão tortos
Mensagens mais tortas
Que a gente se perdeu

O que importa agora
É pegar esse papo
E endireitar 
Puxar
Alongar
Estender
Esticar
Estirar
Até não poder mais

Pra ele chegar longe 
E cada vez mais longe 
poder chegar

Chegar em quem deve 
Chegar em todo mundo
E chegar da forma 
que tem que chegar

Reto
Preciso
E real

Como qualquer papo sério
Precisa chegar`
};

export default papoReto;